import React from 'react';
import './styles.scss';

interface OverlayWhiteProps {
    image: string;
    credits: string;
}

export default function ImageCredits({ image, credits }: OverlayWhiteProps): JSX.Element {
    return (
        <figure className='image-credits'>
            <img src={image} alt='' />
            <figcaption className='label large'>{credits}</figcaption>
        </figure>
    );
}
